/* @flow */

import 'babel-polyfill';

window.BitsOfLove = {};

require('./register-components');
require('./queue-status');
require('./eventmanager');
require('./debug/version');
require('./debug/rollbar');



// WEBPACK FOOTER //
// ./resources/assets/admin/global/js/index.js